import { ChangeEvent, useState } from 'react'
import getTextVisibleLength from 'helpers/getTextVisibleLength'

const useTextHandlers = () => {
  const [text, setText] = useState<string>('')
  const currentTextLength = getTextVisibleLength(text)

  const handleTextareaChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setText(e.target.value)
  }

  return { text, setText, currentTextLength, handleTextareaChange }
}

export { useTextHandlers }
